import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { Utils } from 'src/modules/utils/shared/utils';
import { FileUploadService } from '../../services/file-upload-service';

@Component({
  selector: 'app-sm-image-upload',
  templateUrl: './sm-image-upload.component.html',
  styleUrl: './sm-image-upload.component.scss'
})
export class SmImageUploadComponent {

    app = inject(MainAppService);
    fileUpload = inject(FileUploadService);

    @Input()
    value = "";
    
    @Output()
    valueChange = new EventEmitter<string>();

    remove(): void {
        this.value = "";
        this.valueChange.emit(this.value);
    }

    async upload(): Promise<void> {
        let uploaded = Utils.arrayGetSafe(await this.fileUpload.chooseFile(true, ["png"]), 0);
        this.value = uploaded != null ? Utils.bytesToBase64(uploaded.contents) : "";
        this.valueChange.emit(this.value);
    }
}
